import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-investigation-grid',
  templateUrl: './investigation-grid.component.html',
  styleUrls: ['./investigation-grid.component.css']
})
export class InvestigationGridComponent implements OnInit {
  title = "Case Registered List";
  itemsPerPage: number=5;
  currentPage: number=1;
  Firlist : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

   ngOnInit() {
    this.GetAllFirPaginations(this.itemsPerPage,this.currentPage)
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) { 
    if (this.isSearch)
    this.onSearch(this.s, itemsPerPage, pageNo);
    else   
    this.GetAllFirPaginations(itemsPerPage, pageNo);
  }

  pageChanged(pageNumber:number){ 
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else 
    this.GetAllFirPaginations(this.itemsPerPage, pageNumber);
  }
  // onSearchs(s: Search, itemsPerPage: number, pageNumber: number) {
  //   throw new Error("Method not implemented.");
  // }

  GetAllFirPaginations(itemsPerPage: number, pageNo: number){
   
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllFirPaginations(itemsPerPage,pageNo);
    this.data.subscribe(
         (response: any) => {
          this.Firlist= response.FirModel;    
          this.totalItems= response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;           
       
          document.getElementById('loader-spinner').style.display = "none";
         },    
         (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }
      );    
  }

  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.SearchFirdetails(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.FirModel.length!=0){              
            this.Firlist = data.FirModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/investigationdocs-for-investigation/investigation-grid/investigation-grid.component.ts